import React from 'react';
import { Link } from 'react-router';

import Main from '../layouts/Main';

const Index = () => (
  <Main>
    <article className="post" id="index">
      <header>
        <div className="title">
          <h2><Link to="/">Data engineer and researcher</Link></h2>
          <p>Web-scale pipelines, reproducible research, and retrieval at scale.</p>
        </div>
      </header>
      <p>
        I am a data engineer at{' '}
        <a href="https://ascii.ac.at">ASCII</a>{' '}
        and a doctoral student in Informatics at{' '}
        <a href="https://www.tuwien.at">TU Wien</a>. I live in Vienna.
        I build pipelines that read the web at scale, and the infrastructure
        that keeps the results reproducible.
      </p>
      <p>
        Two of my papers are published in the{' '}
        <Link to="/resume#publications">Journal of Open Source Software</Link>.
        You can read more <Link to="/about">about me</Link>, look at my{' '}
        <Link to="/projects">projects</Link>, or see my{' '}
        <Link to="/resume">resume</Link>. There are also{' '}
        <Link to="/stats">site statistics</Link>, and you can{' '}
        <Link to="/contact">contact</Link> me.
      </p>
    </article>
  </Main>
);

export default Index;
